<template>
  <LmDialog v-model="showModal" :title="dialogTitle" :styles="{ minWidth: '900px' }">
    <template #toolbar-actions>
      <q-btn size="sm" color="tertiary" class="q-mr-sm" label="Save" @click.prevent="save(formData)" />
    </template>
    <template #content>
      <q-card-section :class="{ 'is-collapsed': collapsed }">
        <form class="q-pt-lg">
          <div class="row q-col-gutter-md show-three">
            <div v-for="field in formData.fields" :key="field.name" class="col-xs-4">
              <LmDatePicker
                v-if="field.data_type === 'date'"
                v-model="field.value"
                :label="field.label"
                :options="validToPickerOptions(field.name)"
                :disable="validToDisable(field.name)"
              />
              <q-input
                v-else
                v-model="field.value"
                :required="requireField(field.name)"
                :label="field.label"
                stack-label
                outlined
              />
            </div>
            <div class="col-xs-12 text-center">
              <q-btn v-if="formData.fields.length > 3" @click="collapsed = !collapsed">
                {{ collapsed ? 'Expand' : 'Collapse' }}
              </q-btn>
            </div>
          </div>
        </form>
      </q-card-section>
    </template>
  </LmDialog>
</template>

<script>
import { LmFormObject } from '@/lib/models/lm-form-object.class'
import { cloneDeep, get } from 'lodash'
import hash from 'object-hash'
// Components
import LmDatePicker from '@/reusable/LmDatePicker/LmDatePicker'
import LmDialog from '@/reusable/base-components/LmDialog/LmDialog'

export default {
  name: 'FormPublicaton',
  components: { LmDatePicker, LmDialog },
  props: {
    fields: {
      type: Array,
      required: true
    },
    values: {
      type: [Object, null],
      default: () => {
        return null
      }
    },
    showing: {
      type: Boolean,
      default: false
    },
    editMode: {
      type: Boolean,
      default: false
    },
    requiredFields: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      formData: null,
      collapsed: true
    }
  },
  computed: {
    showModal: {
      get() {
        return this.showing
      },
      set(val) {
        !val && this.closeModal()
      }
    },
    validFromValue() {
      return this.formData.fields.find(field => field.name === 'valid_from').value
    },
    dialogTitle() {
      return this.editMode ? 'Edit title' : 'Add title'
    }
  },
  beforeMount() {
    this.init(this.fields, this.values)
  },
  methods: {
    getDateFieldValue(field) {
      let fieldDef = this.formData.fields.find(entry => entry.name === field)
      return fieldDef.value
    },
    init(fields, values) {
      let data = {
        id: get(this.values, 'id', null),
        fields: []
      }
      data.fields = cloneDeep(fields)
      if (this.editMode && this.values) {
        data.fields.forEach(field => {
          field.value = values[field.name]
        })
      }
      this.$set(this, 'formData', new LmFormObject(data))
    },
    save(formData) {
      let data = {}
      formData.fields.forEach(field => {
        data[field.name] =
          field.data_type === 'date' ? this.formatDateForPost(field.value, this.settings.date_format) : field.value
      })
      data['id'] = formData.id ? formData.id : hash(data)
      this.$emit('save', data)
      this.closeModal()
      this.init(this.fields, this.values)
    },
    closeModal() {
      this.$emit('close-modal')
    },
    requireField(fieldName) {
      return this.requiredFields.includes(fieldName)
    },
    validToPickerOptions(field) {
      if (field !== 'valid_to') return
      return date => date >= this.validFromValue
    },
    validToDisable(field) {
      if (field !== 'valid_to') return
      return !this.validFromValue
    }
  }
}
</script>
